










import { Vue, Prop, Component } from "vue-property-decorator";
import { LectureExtraMaterial as ILectureExtraMaterial } from "@/api/models/lecture-extra-material";
import api from "@/getinfo-api";

@Component
export default class LectureExtraMaterialView extends Vue {
  @Prop() extraMaterial!: ILectureExtraMaterial;
  fullExtraMaterial!: ILectureExtraMaterial;
  @Prop({ default: false }) isLecture?: boolean;
  data() {
    return {
      fullExtraMaterial: undefined
    };
  }

  mounted() {
    if (!this.isLecture) {
      api.CourseLectureApi.getExtraMaterial(
        this.$route.params.courseId,
        this.$route.params.courseLectureId,
        this.extraMaterial.id
      ).then((res: { data: ILectureExtraMaterial }) => {
        this.fullExtraMaterial = res.data;
      });
    } else if (this.isLecture && this.extraMaterial) {
      api.LectureExtraMaterialApi.get(
        this.$route.params.id,
        this.extraMaterial.id
      ).then((res: { data: ILectureExtraMaterial }) => {
        this.fullExtraMaterial = res.data;
      });
    }
  }
}
